import React, { useState, useEffect } from "react";
import { Activities } from "components/utils/Activities";
import { useParams, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Table from "components/utils/Table";
import PermissionAbility from "helpers/PermissionAbility";
import PartNameService from "services/PartNameService";
import PartService from "services/PartService";

const Show = () => {
  const [loading, setLoading] = useState(false);
  const [partName, setPartName] = useState([]);
  const [tab, setTab] = useState("parts");
  const [parts, setParts] = useState([]);
  const [partNameQty, setPartNameQty] = useState("");
  let { id } = useParams();
  const navigate = useNavigate();

  const columns = [
    {
      name: "Part Number",
      selector: (row) => row.part_name?.part_number ?? "--",
      sortable: true,
      field: "part_number",
    },
    {
      name: "BIN/Location",
      selector: (row) => row.bin_location?.name ?? "--",
      sortable: true,
      field: "machine",
      format: (row) => (
        <Link
          to={"/panel/bin-location/" + row?.bin_location_id}
          className="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6"
        >
          {row?.bin_location?.name}
        </Link>
      ),
    },
    {
      name: "Unit",
      selector: (row) => row.qty ?? "--",
      sortable: true,
      field: "qty",
    },
    {
      name: "Unit Price",
      selector: (row) => row.unit_price ?? "--",
      sortable: true,
      field: "unit_price",
    },
    {
      name: "Machine Model",
      selector: (row) => row.machine_model?.name ?? "--",
      sortable: true,
      field: "machine_model",
      format: (row) => (
        <Link
          to={
            "/panel/machines/" +
            row?.machine_id +
            "/models/" +
            row?.machine_model_id
          }
          className="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6"
        >
          {row?.machine_model?.name}
        </Link>
      ),
    },
    {
      name: "Action",
      selector: (row) => row.part_name_id,
      maxWidth: "150px",
      format: (row) => (
        <span className="text-end">
          <PermissionAbility permission="parts_show">
            <Link
              to={"/panel/parts/" + row.id}
              className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
            >
              <i className="fa fa-eye"></i>
            </Link>
          </PermissionAbility>
        </span>
      ),
    },
  ];

  const getPartName = async () => {
    setLoading(true);
    setPartName(await PartNameService.get(id));
    setLoading(false);
  };

  const getPartNameQty = async () => {
    setPartNameQty(await PartNameService.getQty(id));
    setLoading(false);
  };

  const getParts = async (filters) => {
    filters.part_name_id = id;
    setLoading(true);
    let dt = await PartService.getAll(filters);
    setParts(dt);
    setLoading(false);
  };

  useEffect(() => {
    if (id) {
      getPartName();
      getPartNameQty();
    }
  }, [id]);

  return (
    <div className="d-flex flex-column-fluid">
      <div className="container">
        <div className="row">
          <div className="col-xl-4">
            <div className="card card-custom">
              <div className="card-header h-auto py-4">
                <div className="card-title">
                  <h3 className="card-label">
                    <button
                      className="btn btn-sm btn-dark "
                      style={{ marginRight: "0.75rem" }}
                      onClick={() => navigate(-1)}
                    >
                      <i className="fa fa-arrow-left"></i>Back
                    </button>
                    Details
                  </h3>
                </div>
              </div>

              <div className="card-body py-4">
                <div className="form-group row my-2">
                  <label className="col-4 col-form-label">Name:</label>
                  <div className="col-8">
                    <span className="form-control-plaintext font-weight-bolder">
                      {partName?.name}
                    </span>
                  </div>
                </div>

                <div className="form-group row my-2">
                  <label className="col-4 col-form-label">
                    Total Quantity:
                  </label>
                  <div className="col-8">
                    <span className="form-control-plaintext font-weight-bolder">
                      {partNameQty[0]?.totalQty ?? "--"}
                    </span>
                  </div>
                </div>

                <div className="form-group row my-2">
                  <label className="col-4 col-form-label">Description:</label>
                  <div className="col-8">
                    <span className="form-control-plaintext font-weight-bolder">
                      {partName?.description}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-8">
            <div className="flex-lg-row-fluid ms-lg-15">
              <ul className="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-bold mb-8">
                <PermissionAbility permission="warehouses_parts_access">
                  <li className="nav-item">
                    <a
                      className={`nav-link text-active-primary pb-4 ${
                        tab == "parts" ? "active" : ""
                      }`}
                      data-bs-toggle="tab"
                      href="#parts"
                      onClick={() => setTab("parts")}
                    >
                      Parts List
                    </a>
                  </li>
                </PermissionAbility>

                <li className="nav-item">
                  <a
                    className={`nav-link text-active-primary pb-4 ${
                      tab == "activities" ? "active" : ""
                    }`}
                    data-bs-toggle="tab"
                    href="#activities"
                    onClick={() => setTab("activities")}
                  >
                    Activities
                  </a>
                </li>
              </ul>

              <div className="tab-content">
                <PermissionAbility permission="warehouses_parts_access">
                  <div
                    className={`tab-pane fade ${
                      tab == "parts" ? "active show" : ""
                    }`}
                    id="parts"
                    role="tabpanel"
                  >
                    <div className="card mb-5 mb-xl-8">
                      <div className="card-body py-3">
                        <Table
                          name="Parts"
                          isLoading={loading}
                          data={parts}
                          columns={columns}
                          onFilter={getParts}
                        />
                      </div>
                    </div>
                  </div>
                </PermissionAbility>

                <Activities logName="part-name" modelId={id} tab={tab} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Show;
